module.exports = __webpack_public_path__ + "img/btn_color.6a299d47.svg";